import styles from './MainNav.module.css'
import {UserAdminActions} from '@peachy/web-dashboard-pure'
import {A} from '@solidjs/router'
import {useUserAdminService} from '../../controllers/DashboardServiceController'

export function MainNav() {
    const userAdminService = useUserAdminService()
    console.log(userAdminService)
    
    const areYouSure = async () => {
        const ok = window.confirm('are you sure')
        if (ok) {
            try { 
                await Promise.all([
                    userAdminService.clearMembers(),
                    userAdminService.clearPortalAdmins()
                ])
                window.alert(`members and portal admins deleted`)
            } catch (e) {
                console.error(e)
                window.alert('something went wrong.  please try again')
            }
                
        }
    }
    return (
        <nav class={styles.MainNav}>
            <ul>
                {/*<li><IamLink path={"/premium-bdx"} groups={[AdminUserGroup, InsurerUserGroup]} >Premium Bordereaux</IamLink></li>*/}
                {/*<li><IamLink path={"/claim-bdx"} groups={[AdminUserGroup, InsurerUserGroup]} >Claim Bordereaux</IamLink></li>*/}
                <li><A href={`/${UserAdminActions.newCustomerPassword}`}>New Customer Password</A></li>
                <li><A href={`/${UserAdminActions.newDashUserPassword}`} >New Dash User Password</A></li>
                {/*<li><IamLink path={`/payments`} groups={AdminUserGroup}>Payments</IamLink></li>*/}
                <li><A href={`/group-subscription`}>Group Subscription</A></li>
                {/*<li><IamLink path={`/scratch`} groups={AdminUserGroup}>Scratch</IamLink></li>*/}
                <li>
                    <br/>
                    <button onClick={areYouSure}>Clear users</button>
                </li>
            </ul>
        </nav>
    )
}
